import React, { Component, Fragment } from 'react'
import { SplitScreenLayout } from 'app/common/layout'
import { MailForm, UpdateForm } from './forms'
import { injectIntl } from 'react-intl'
import type { IntlShape } from 'react-intl'

type Props = {
    resetPassword: () => void,
    getUrlParams: () => void,
    authenticationIsFromUrl?: string,
    token: string,
    error: any,
    networkError: any,
    intl: IntlShape,
    navigate: (to: string, state?: any) => void
}

class ResetPassword extends Component<Props> {
    componentDidMount() {
        const { getUrlParams } = this.props
        getUrlParams()
    }

    componentWillUnmount() {
        const { resetPassword } = this.props
        resetPassword()
    }

    goBack = () => {
        const { authenticationIsFromUrl, navigate, intl } = this.props
        if (authenticationIsFromUrl) {
            navigate(
                intl.formatMessage({
                    id: 'routes.clickandcollect.signin.signup'
                }),
                {
                    fromUrl: authenticationIsFromUrl
                }
            )
        } else {
            navigate(
                intl.formatMessage({
                    id: 'routes.signin'
                })
            )
        }
    }

    render() {
        const {
            error,
            networkError,
            authenticationIsFromUrl,
            token
        } = this.props
        return (
            <Fragment>
                {token ? (
                    <SplitScreenLayout
                        breadcrumbKey="reset.password.breadcrumb.end"
                        titleKey="reset.password.update.title"
                        leftBlock={<UpdateForm />}
                        nothingOnTheRight={true}
                        fromEcommerce={!!authenticationIsFromUrl}
                        error={error}
                        networkError={networkError}
                    />
                ) : (
                    <SplitScreenLayout
                        breadcrumbKey="reset.password.breadcrumb.end"
                        titleKey="reset.password.mail.title"
                        leftBlock={<MailForm goBack={this.goBack} />}
                        nothingOnTheRight={true}
                        fromEcommerce={!!authenticationIsFromUrl}
                        error={error}
                        networkError={networkError}
                    />
                )}
            </Fragment>
        )
    }
}

const ResetPasswordComponent = injectIntl(ResetPassword)

export { ResetPasswordComponent }
